import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function Contracts() {
  const [suppliers, setSuppliers] = useState([]);
  useEffect(() => { api.get("/suppliers").then(({ data }) => setSuppliers(data)); }, []);
  const supplierMap = Object.fromEntries(suppliers.map((s) => [s.id, s.name]));
  return (
    <ResourcePage
      endpoint="/contracts"
      testidPrefix="contract"
      eyebrow="Stakeholders"
      title="Supplier Contracts"
      subtitle="Track contracts, terms, values and renewal dates with suppliers."
      ctaLabel="Add contract"
      fields={[
        { name: "supplier_id", label: "Supplier", type: "select", required: true,
          options: suppliers.map((s) => ({ value: s.id, label: s.name })) },
        { name: "title", label: "Contract title", required: true },
        { name: "start_date", label: "Start date", type: "date" },
        { name: "end_date", label: "End date", type: "date" },
        { name: "value", label: "Contract value", type: "number" },
        { name: "currency", label: "Currency", default: "UGX" },
        { name: "status", label: "Status", type: "select", default: "active",
          options: ["active", "expired", "terminated"] },
        { name: "notes", label: "Notes", type: "textarea" },
      ]}
      columns={[
        { key: "title", label: "Contract" },
        { key: "supplier_id", label: "Supplier", render: (i) => supplierMap[i.supplier_id] || "—" },
        { key: "start_date", label: "Start" },
        { key: "end_date", label: "End" },
        { key: "value", label: "Value", render: (i) => i.value ? `${i.currency || "UGX"} ${Number(i.value).toLocaleString()}` : "—" },
        { key: "status", label: "Status", render: (i) => <Badge tone={i.status === "active" ? "emerald" : i.status === "expired" ? "amber" : "gray"}>{i.status}</Badge> },
      ]}
      searchKeys={["title", "notes"]}
    />
  );
}
